import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { users } from '../../../actions'
import { translate } from '../../../helpers/stringHelpers'
import useAccountDetailsSync, { ACCOUNT_DETAILS_SYNC_SUCCESS_EVENT, ACCOUNT_DETAILS_SYNC_SUCCESS_STORAGE_KEY } from '../../hooks/useAccountDetailsSync'

const isAccountPage = () => {
  const { hash, pathname } = window.location
  return hash.startsWith('#!/account') || pathname === '/account' || pathname.endsWith('/account')
}

const SessionChecker = () => {
  const dispatch = useDispatch()
  const userUuid = useSelector(state => state.users.user.uuid)
  const hasOAuthEnabled = useSelector(state => !!state.config.input.options.oAuth)
  const { checkAndUpdateAccountDetails } = useAccountDetailsSync()

  const checkSession = useCallback(async () => {
    try {
      const userSession = await dispatch(users.getUserSession())
      console.log('>>>>> Session check completed, userSession:', userSession)
      if (userSession?.session) {
        const hasUpdatedAccountDetails = await checkAndUpdateAccountDetails(userSession?.session)
        console.log('>>>>> Session check completed, hasUpdatedAccountDetails:', hasUpdatedAccountDetails)
        if (hasUpdatedAccountDetails) {
          if (hasOAuthEnabled) {
            await dispatch(users.getFreshUserModel())
          }

          toast.success(translate('JspPublicCodes_JSP_MY_SETTINGS_CHANGES_APPLIED'), {
            toastId: 'account-details-sync-success'
          })

          if (isAccountPage()) {
            console.log('>>>>> Session sync success on account page, setting session storage flag')
            window.sessionStorage.setItem(ACCOUNT_DETAILS_SYNC_SUCCESS_STORAGE_KEY, '1')
            window.dispatchEvent(new CustomEvent(ACCOUNT_DETAILS_SYNC_SUCCESS_EVENT))
          }
        }
      }
    } catch (error) {
      console.error('Session check failed', error)
    }
  }, [dispatch, checkAndUpdateAccountDetails, hasOAuthEnabled])

  useEffect(() => {
    if (!userUuid) {
      return
    }

    const interval = setInterval(checkSession, process.env.REACT_APP_SESSION_CHECK_TIME || 15000)
    return () => clearInterval(interval)
  }, [checkSession, userUuid])

  return null
}

export default SessionChecker
